import { render, staticRenderFns } from "./WalletsCard.htm?vue&type=template&id=6e2019bb&scoped=true&"
import script from "./WalletsCard.js?vue&type=script&lang=js&"
export * from "./WalletsCard.js?vue&type=script&lang=js&"
import style0 from "./WalletsCard.scss?vue&type=style&index=0&id=6e2019bb&lang=scss&scoped=true&"
import style1 from "../WalletCard.scss?vue&type=style&index=1&id=6e2019bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2019bb",
  null
  
)

export default component.exports